import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Core Axios instance used across the app
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Helper to get the absolute URL for a specific tool.
 */
export function toolEndpoint(toolSlug) {
  return `${API}/tools/${toolSlug}`;
}

/**
 * Universal utility to submit tool files to the new backend endpoints.
 */
export async function submitToolForm(toolSlug, formData) {
  try {
    const response = await api.post(`/tools/${toolSlug}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.error || error.message;
    throw new Error(formatApiErrorDetail(detail));
  }
}

/**
 * Error formatting logic
 */
export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

/**
 * Bytes conversion utility
 */
export function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let val = bytes;
  let i = 0;
  while (val >= 1024 && i < units.length - 1) { val /= 1024; i++; }
  return `${val.toFixed(val < 10 ? 1 : 0)} ${units[i]}`;
}
